/**
 * Concept Archetype
 *
 * @author Daniel Lepe
 * @date 05/Oct/2023
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'bloqueodefechas'

const baseIndex = baseController + '/index'

const archetype = [
    {
        key: 'id',
        type: 'hidden'
    },
    {
        key: 'lunch_cedes_id',
        label: 'Sede',
        type: 'select',
        options: [],
    },
    {
        key: 'fecha_bloqueo',
        type: 'date'
    },
    {
        key: 'comentario',
        type: 'textarea',
        max: 155
    }
    
];

const captions = [
    {key: 'fecha_bloqueo', label: 'Fecha de Bloqueo'},
    {key: 'cede_titulo', label: 'Sede asignada'},
    {key: '_'},
    {key: 'comentario', label: 'Comentario'},
    // {key: 'lunch_cedes_id', label: 'Lunch Cedes ID'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

export {
    archetype,
    captions,
    baseIndex,
    automodalHandler
}
